import React from 'react';

import { StoreProvider } from 'easy-peasy';
import { I18nextProvider } from 'react-i18next';

import { createRoot } from 'react-dom/client';
import { ThemeProvider as LyraThemeProvider } from '@responsive-lyra/ui';
import globalStore from '@store/global/GlobalStore';
import { ThemeProvider } from '@contexts/ThemeContext';
// App is part of the critical startup path, so we import it eagerly to avoid
// adding an extra async chunk before the first render.
import App from './App';

import i18n from './i18n';

import './styles/index.css';
import '@responsive-lyra/ui/style';

const AppPage = () => {
  return (
    // Match responsive-lite AppWrapper: Lyra ThemeProvider outermost, then app theme.
    <LyraThemeProvider data-qa='theme-provider' theme='default' colorMode='light'>
      <I18nextProvider i18n={i18n}>
        <StoreProvider store={globalStore}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </StoreProvider>
      </I18nextProvider>
    </LyraThemeProvider>
  );
};

const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element #app not found');
}
const root = createRoot(container);
root.render(<AppPage />);

// Only register the service worker for production builds so local development
// stays predictable and avoids stale cached assets while iterating.
const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  import('./service-worker')
    .then(({ default: registerServiceWorker }) => {
      registerServiceWorker();
    })
    .catch(() => {
      // Service worker registration is non-blocking for app startup.
    });
}
